import UIGrid from '@mui/material/GridLegacy';

import styled from 'styled-components';
import SelectableRow from '../../../../components/SelectableRow';
import { Colors } from '../../../../utils/style/colors';
import { Text } from '../../../../utils/style/texts';

export const Grid = styled(UIGrid)`
	* {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
    }
`;

// Grows past its half instead of cutting the date off; the next cell wraps.
export const DateCell = styled(UIGrid)`
	&& {
		max-width: none;
		min-width: max-content;
	}
`;

export const AlertItem = styled(SelectableRow)`
	${props => `
		transition: all .3s;
		${!props.onClick && `
			pointer-events: none !important;
		`};
		${props.disabled && `
			opacity: .5;
			pointer-events: none;
		`};
		${props.alarm && props.alarm.handledBy && `
			position: relative;
			&:before {
				content: ' ';
				display: block;
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
			}
		`};
		
		${props.needsAttention && `
			animation: attention .7s 3;
		`};
		
		@keyframes attention {
			0% { background: white; }
			50% { background: orange; }
			100% { background: white; }
		}
	`}
`;

export const SituationStatus = styled(Text)`
	color: ${props => props.$muted ? Colors.gray40 : 'inherit'};
`;

export const StatusDot = styled.span`
	display: inline-block;
	width: 8px;
	height: 8px;
	margin-right: 6px;
	border-radius: 50%;
	vertical-align: middle;
	background: ${props => props.$color};
`;
